import { render } from "./SectionIntro2.vue?vue&type=template&id=6edf81b3"
import script from "./SectionIntro2.vue?vue&type=script&lang=js"
export * from "./SectionIntro2.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__